/* ZENTO RIDERS — motore condiviso della pagina del Club.
   - la texture "a puntini" (dithering) della Rider Card, disegnata dalla scheda video
   - l'inclinazione della card sotto al mouse, con il riflesso
   - il conto alla rovescia all'1 ottobre
   - l'anteprima dal vivo della card mentre si compila il modulo
   - la Story 1080x1920 da scaricare o condividere
   Sicurezza: i testi scritti dall'utente passano SOLO da textContent e da fillText
   del canvas, mai da innerHTML. Niente librerie esterne, niente chiamate a server terzi. */
(function () {
  'use strict';
  if (window.ZR) { window.ZR.boot(); return; }

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MAX_LIVE = 3, live = 0;

  function hex(c) {
    c = String(c || '').trim();
    var m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(c);
    if (!m) return [0.5, 0.5, 0.5];
    var h = m[1].length === 3 ? m[1].replace(/(.)/g, '$1$1') : m[1];
    return [parseInt(h.slice(0, 2), 16) / 255, parseInt(h.slice(2, 4), 16) / 255, parseInt(h.slice(4, 6), 16) / 255];
  }
  function tones(el) {
    var s = getComputedStyle(el);
    return [hex(s.getPropertyValue('--c0')), hex(s.getPropertyValue('--c1')), hex(s.getPropertyValue('--c2'))];
  }

  /* ── lo stesso disegno in JavaScript: serve per le card piccole, per la Story
        e quando il telefono non ha la scheda video disponibile ── */
  function h2(x, y) {
    var px = (x * 123.34) % 1, py = (y * 456.21) % 1;
    if (px < 0) px += 1; if (py < 0) py += 1;
    var d = px * (px + 45.32) + py * (py + 45.32);
    px += d; py += d;
    var r = (px * py) % 1; return r < 0 ? r + 1 : r;
  }
  function vn(x, y) {
    var ix = Math.floor(x), iy = Math.floor(y), fx = x - ix, fy = y - iy;
    var ux = fx * fx * (3 - 2 * fx), uy = fy * fy * (3 - 2 * fy);
    var a = h2(ix, iy), b = h2(ix + 1, iy), c = h2(ix, iy + 1), d = h2(ix + 1, iy + 1);
    return (a + (b - a) * ux) + ((c + (d - c) * ux) - (a + (b - a) * ux)) * uy;
  }
  function fbm(x, y) {
    var v = 0, a = 0.5;
    for (var i = 0; i < 4; i++) { v += a * vn(x, y); x = x * 2.03 + 17.1; y = y * 2.03 + 17.1; a *= 0.5; }
    return v;
  }
  function field(u, v, t, seed) {
    var qx = fbm(u * 1.6 + t + seed, v * 1.6 + t + seed), qy = fbm(u * 1.6 - t + 5.2, v * 1.6 - t + 5.2);
    var w = fbm(u * 2.2 + 2 * qx + t * 0.7, v * 2.2 + 2 * qy - t * 0.4);
    return 0.5 + 0.5 * Math.sin(w * 9 + v * 3);
  }
  function paint(ctx, W, H, cols, seed) {
    var img = ctx.createImageData(W, H), d = img.data, c8 = cols.map(function (c) { return c.map(function (x) { return Math.round(x * 255); }); });
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
      var lvl = field(x / H, (H - y) / H, 0, seed) * 1.35 - 0.2, th = h2(x + 0.5, y + 0.5);
      var c = c8[0]; if (lvl > th) c = c8[1]; if (lvl - 0.55 > th * 0.8) c = c8[2];
      var i = (y * W + x) * 4; d[i] = c[0]; d[i + 1] = c[1]; d[i + 2] = c[2]; d[i + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
  }
  var stillCache = {};
  function still(cols, seed) {
    var k = cols.join('|') + '|' + seed;
    if (stillCache[k]) return stillCache[k];
    var c = document.createElement('canvas'); c.width = 150; c.height = 240;
    paint(c.getContext('2d'), 150, 240, cols, seed);
    return (stillCache[k] = c.toDataURL('image/png'));
  }

  /* Senza precisione piena nei fragment shader il nostro rumore degenera in una tinta
     piatta: in quel caso e meglio non usare il WebGL e tenere la versione disegnata. */
  function precisionePiena(g) {
    try {
      var p = g.getShaderPrecisionFormat(g.FRAGMENT_SHADER, g.HIGH_FLOAT);
      return !!(p && p.precision > 0);
    } catch (e) { return false; }
  }

  /* Una tela va misurata solo quando la misura ESISTE. Se l elemento non e ancora
     impaginato clientWidth e 0, e un max(1, 0) trasformerebbe "non lo so" in "1 pixel":
     la tela finisce 1x1 e viene stirata su tutta la card. Da fuori sembra zoomata e rotta. */
  function misuraVera(cv) {
    var w = cv.clientWidth, h = cv.clientHeight;
    if (!(w > 0 && h > 0)) return null;
    /* ⚠️ La densita va arrotondata a un NUMERO INTERO, e non e un dettaglio.
       I pallini sono una griglia regolare (floor(coord/uP)). Se la densita e frazionaria
       - sui Mac con risoluzione "piu spazio" vale 1.25 o 1.7 - il passo della griglia non
       cade su un numero intero di pixel CSS, il browser la ricampiona storta e nasce il
       MOIRE: una trama grande e finta che sembra la stessa cosa ripetuta molte volte, e che
       STRISCIA mentre il rumore si muove. E il difetto che Mirco vedeva solo in movimento.
       Con un intero il passo torna esatto (2 px CSS) a qualunque densita. */
    var dpr = Math.min(2, Math.max(1, Math.round(window.devicePixelRatio || 1)));
    return { w: Math.round(w * dpr), h: Math.round(h * dpr), dpr: dpr };
  }
  /* riprova a misurare finche la pagina non si e assestata; se non ci riesce, chiama rinuncia() */
  function quandoMisurabile(cv, fatto, rinuncia) {
    var attese = [0, 100, 400, 1200], i = 0;
    (function prova() {
      var m = misuraVera(cv);
      if (m) return fatto(m);
      if (i >= attese.length) return rinuncia();
      var t = attese[i++];
      if (t === 0) requestAnimationFrame(prova); else setTimeout(prova, t);
    })();
  }

  /* ── la versione animata, sulla scheda video ── */
  var VS = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  var FS = [
    /* la parte decimale di numeri grandi serve intera: a meta precisione si perde
       e la trama diventa una tinta piatta (succedeva su Android) */
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform vec2 uR;uniform float uT;uniform float uP;uniform float uS;uniform vec3 c0;uniform vec3 c1;uniform vec3 c2;',
    /* (Mirco 27.10, Mac 2016: lo sfondo veniva "a blocchi" coi bordi dritti) il vecchio hash moltiplicava per 456 dei
     numeri che arrivano a ~400: 190.000, e la parte decimale di numeri cosi grandi certe schede grafiche (Intel su Mac)
     la sbagliano. Ora le coordinate si riportano sotto 289 e l'hash (Dave Hoskins) lavora solo con numeri piccoli:
     lo stesso disegno a onde, uguale su tutte le macchine. */
    'float h(vec2 p){p=mod(p,289.);vec3 q=fract(vec3(p.xyx)*.1031);q+=dot(q,q.yzx+33.33);return fract((q.x+q.y)*q.z);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);',
    ' return mix(mix(h(i),h(i+vec2(1.,0.)),u.x),mix(h(i+vec2(0.,1.)),h(i+vec2(1.,1.)),u.x),u.y);}',
    'float fb(vec2 p){float v=0.,a=.5;for(int i=0;i<4;i++){v+=a*n(p);p=p*2.03+17.1;a*=.5;}return v;}',
    'void main(){',
    ' vec2 px=floor(gl_FragCoord.xy/uP);vec2 uv=px*uP/uR.y;float t=uT*.045;',
    ' vec2 q=vec2(fb(uv*1.6+t+uS),fb(uv*1.6-t+5.2));',
    ' float w=fb(uv*2.2+2.*q+vec2(t*.7,-t*.4));',
    /* mod(): sugli schermi con tanti pixel (Mac retina) px*456 diventa enorme e la parte decimale si sgrana
       a blocchi (Mirco 13.10). Ripetere ogni 256 celle non si vede ed evita numeri grandi. */
    ' float lvl=(.5+.5*sin(w*9.+uv.y*3.))*1.35-.2;float th=h(mod(px,256.)+.5);',
    ' vec3 c=c0;if(lvl>th)c=c1;if(lvl-.55>th*.8)c=c2;',
    ' gl_FragColor=vec4(c,1.);}'
  ].join('\n');

  function startGL(card) {
    var cv = card.querySelector('.zr-gl');
    if (!cv || live >= MAX_LIVE) return false;
    var o = { antialias: false, alpha: false, depth: false, stencil: false, powerPreference: 'low-power', premultipliedAlpha: false };
    var g = null;
    try { g = cv.getContext('webgl2', o) || cv.getContext('webgl', o); } catch (e) { g = null; }
    if (!g) return false;
    if (!precisionePiena(g)) return false;   /* si tiene la versione disegnata */
    function sh(type, src) { var s = g.createShader(type); g.shaderSource(s, src); g.compileShader(s); return g.getShaderParameter(s, g.COMPILE_STATUS) ? s : null; }
    var vs = sh(g.VERTEX_SHADER, VS), fs = sh(g.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return false;
    var pr = g.createProgram(); g.attachShader(pr, vs); g.attachShader(pr, fs); g.linkProgram(pr);
    if (!g.getProgramParameter(pr, g.LINK_STATUS)) return false;
    g.useProgram(pr);
    var b = g.createBuffer(); g.bindBuffer(g.ARRAY_BUFFER, b);
    g.bufferData(g.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), g.STATIC_DRAW);
    var loc = g.getAttribLocation(pr, 'p'); g.enableVertexAttribArray(loc); g.vertexAttribPointer(loc, 2, g.FLOAT, false, 0, 0);
    var U = {}; ['uR', 'uT', 'uP', 'uS', 'c0', 'c1', 'c2'].forEach(function (k) { U[k] = g.getUniformLocation(pr, k); });
    var seed = parseFloat(card.getAttribute('data-seed')) || 0;
    function colors() { var t = tones(card); g.uniform3fv(U.c0, t[0]); g.uniform3fv(U.c1, t[1]); g.uniform3fv(U.c2, t[2]); }
    colors(); g.uniform1f(U.uS, seed);
    var misurata = false, dpr = 1, vis = true, run = false, t0 = performance.now(), acc = seed * 40, raf = 0, lost = false;
    /* torna true solo se ha potuto misurare per davvero (vedi misuraVera) */
    function size() {
      var m = misuraVera(cv);
      if (!m) return false;
      dpr = m.dpr;
      if (cv.width !== m.w || cv.height !== m.h) { cv.width = m.w; cv.height = m.h; }
      g.viewport(0, 0, m.w, m.h); g.uniform2f(U.uR, m.w, m.h); g.uniform1f(U.uP, Math.max(2, Math.round(2.2 * dpr)));
      misurata = true; return true;
    }
    function draw() { if (lost || !misurata) return; g.uniform1f(U.uT, acc); g.drawArrays(g.TRIANGLE_STRIP, 0, 4); }
    function frame(now) {
      raf = 0; if (!run) return;
      acc += Math.min(64, now - t0) / 1000; t0 = now; draw();
      raf = requestAnimationFrame(frame);
    }
    function play() {
      var want = vis && !document.hidden && !reduce;
      if (want && !run) { run = true; t0 = performance.now(); raf = requestAnimationFrame(frame); }
      if (!want && run) { run = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
    }
    /* se la card non e ancora impaginata si aspetta: meglio un attimo di nero che una macchia stirata.
       Se non arriva mai una misura, si passa alla versione ferma (quella della Hall of Fame). */
    quandoMisurabile(cv, function () { size(); draw(); }, function () { lost = true; live--; useStill(card); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (size()) draw(); }).observe(cv);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { vis = en[0].isIntersecting; play(); }).observe(card);
    document.addEventListener('visibilitychange', play);
    cv.addEventListener('webglcontextlost', function (e) { e.preventDefault(); lost = true; run = false; useStill(card); });
    card.__zrRecolor = function () { colors(); draw(); };
    live++; play();
    return true;
  }
  function useStill(card) {
    var st = card.querySelector('.zr-still'), cv = card.querySelector('.zr-gl');
    if (cv) cv.style.display = 'none';
    if (st) st.style.backgroundImage = 'url(' + still(tones(card), parseFloat(card.getAttribute('data-seed')) || 0) + ')';
  }

  /* ── inclinazione sotto al mouse (solo dove c'è un mouse vero) ── */
  function tilt(card) {
    if (reduce) return;
    var el = card.querySelector('.zr-tilt'), raf = 0, px = 0.5, py = 0.5, back = 0;
    if (!el) return;
    function aim(e) {
      var r = card.getBoundingClientRect();
      px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
      card.classList.add('is-tilting');
      if (back) { clearTimeout(back); back = 0; }
      if (!raf) raf = requestAnimationFrame(function () {
        raf = 0;
        el.style.transform = 'rotateY(' + ((px - 0.5) * 16).toFixed(2) + 'deg) rotateX(' + ((0.5 - py) * 14).toFixed(2) + 'deg) scale(1.02)';
        card.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
    }
    function rest(delay) {
      if (back) clearTimeout(back);
      back = setTimeout(function () { back = 0; card.classList.remove('is-tilting'); el.style.transform = ''; }, delay || 0);
    }
    /* mouse: segue il puntatore */
    card.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' || e.pointerType === 'pen' || e.buttons) aim(e); });
    card.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') rest(0); });
    /* dito: tocco e trascino di lato = la card si inclina; su e giù la pagina scorre normale */
    card.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') aim(e); });
    card.addEventListener('pointerup', function (e) { if (e.pointerType === 'touch') rest(650); });
    card.addEventListener('pointercancel', function () { rest(250); });
  }

  function initCard(card) {
    if (card.__zr) return; card.__zr = 1;
    var ok = card.hasAttribute('data-live') && startGL(card);
    if (!ok) useStill(card);
    tilt(card);
  }

  /* ── conto alla rovescia ── */
  function count(el) {
    if (el.__zr) return; el.__zr = 1;
    var end = Date.parse(el.getAttribute('data-zr-count'));
    if (isNaN(end)) { el.hidden = true; return; }
    var U = {}; ['d', 'h', 'm', 's', 'c'].forEach(function (k) { U[k] = el.querySelector('[data-u="' + k + '"]'); });
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { el.classList.add('is-live'); if (U.c) U.c.textContent = '00'; return false; }
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (U.d) U.d.textContent = p2(d); if (U.h) U.h.textContent = p2(h);
      if (U.m) U.m.textContent = p2(m); if (U.s) U.s.textContent = p2(s);
      if (U.c) U.c.textContent = p2(Math.floor((ms % 1000) / 10));
      return true;
    }
    /* coi centesimi il conto corre a ogni fotogramma: mette fretta. Senza, basta una volta al secondo */
    if (U.c && !reduce) {
      (function giro() { if (tick()) requestAnimationFrame(giro); })();
    } else if (tick()) { var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000); }
  }

  /* ── anteprima dal vivo: il modulo scrive sulla card, solo come testo ── */
  function lenClass(s) { s = s.length; return s > 16 ? 'l' : s > 10 ? 'm' : ''; }
  function bind(form) {
    if (form.__zr) return; form.__zr = 1;
    var card = document.getElementById(form.getAttribute('data-zr-preview'));
    if (!card) return;
    [].forEach.call(form.querySelectorAll('[data-zr-in]'), function (inp) {
      var key = inp.getAttribute('data-zr-in');
      function up() {
        var v = inp.type === 'checkbox' ? inp.checked : String(inp.value || '').replace(/\s+/g, ' ').trim();
        [].forEach.call(card.querySelectorAll('[data-zr-f="' + key + '"]'), function (t) {
          if (key === 'hof') { t.textContent = v ? (t.getAttribute('data-on') || 'ON') : (t.hasAttribute('data-off') ? t.getAttribute('data-off') : 'OFF'); return; }
          if (key === 'ig' && v) v = '@' + v.replace(/^@+/, '');
          t.textContent = v || t.getAttribute('data-empty') || '';
          if (key === 'name') t.setAttribute('data-l', lenClass(v || t.getAttribute('data-empty') || ''));
        });
      }
      inp.addEventListener('input', up); inp.addEventListener('change', up); up();
    });
  }

  /* ── la Story 1080x1920 ── */
  function fontOf(el) {
    var f = getComputedStyle(el).getPropertyValue('--zr-head') || '';
    f = f.trim(); return f && f !== 'inherit' ? f : getComputedStyle(el).fontFamily;
  }
  function rr(ctx, x, y, w, h, r) {
    ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }
  function fitText(ctx, txt, max, size, weight, fam) {
    do { ctx.font = weight + ' ' + size + 'px ' + fam; size -= 4; } while (ctx.measureText(txt).width > max && size > 20);
  }
  /* ── il poster "01 · ONE YEAR IN" (era "I WAS HERE", cambiato il 27.09: troppo simile a "Io c'ero"): rifatto a STRATI come il PSD di Mirco (poster I WAS HERE.psd, 26.09) ──
     Dal basso: la foto intera · nero in basso · arancio-rosso in basso · nero in alto · "01/10/2026" e "1° year"
     in luce soffusa · le due trame a puntini (verde acqua e nera, al 25%: file zr-poster-trama.png) · le scritte.
     La foto si vede davvero: le sfumature la coprono solo in cima e in fondo, come nel file originale.
     Il file originale è 1400x2436: si disegna nelle sue misure e si riporta su 1080x1920. */
  function mix(a, b, t) { return Math.round(a + (b - a) * t); }
  function sfumatura(x, W, H, fermate) {
    var g = x.createLinearGradient(0, 0, 0, H);
    fermate.forEach(function (f) { g.addColorStop(f[0], 'rgba(' + f[1] + ',' + f[2] + ',' + f[3] + ',' + f[4] + ')'); });
    x.fillStyle = g; x.fillRect(0, 0, W, H);
  }
  function drawStory(data, withPhoto) {
    var W = 1080, H = 1920, c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d');
    var F = 'Inter, "Helvetica Neue", Arial, sans-serif';

    /* 1. la foto, a tutta pagina (con zoom e posizione scelti dal rider) */
    x.fillStyle = '#3a3d3d'; x.fillRect(0, 0, W, H);
    /* la foto puo essere una <img> (naturalWidth) o una ImageBitmap gia raddrizzata (width) */
    var fotoIW = data.img ? (data.img.naturalWidth || data.img.width || 0) : 0;
    var fotoIH = data.img ? (data.img.naturalHeight || data.img.height || 0) : 0;
    var fotoPronta = !!(data.img && fotoIW && fotoIH && (data.img.complete === undefined || data.img.complete));
    if (withPhoto && fotoPronta) {
      var iw = fotoIW, ih = fotoIH, ps = data.pos || {}, pz = ps.z || 1;
      /* Un minimo di ingrandimento serve al CONTROLLO, non alla grafica: "a riempire" lascia
         zero avanzo sull asse in cui la foto gia combacia, e li il cursore non puo spostare
         niente (era il "destra e sinistra si muove pochissimo"). Con questo c e sempre gioco
         su tutti e due gli assi. */
      var ZOOM_MINIMO = 1.12;
      var k = Math.max(W / iw, H / ih) * Math.max(pz, ZOOM_MINIMO);
      var ppx = ps.x != null ? ps.x / 100 : 0.5, ppy = ps.y != null ? ps.y / 100 : 0.5;
      x.drawImage(data.img, (W - iw * k) * ppx, (H - ih * k) * ppy, iw * k, ih * k);
    } else {
      /* finché non c'è la foto: un grigio con la scritta, così si capisce cosa manca */
      x.fillStyle = 'rgba(255,255,255,.55)'; x.textAlign = 'center'; x.font = '800 40px ' + F;
      x.fillText('LA FOTO DELLA TUA MOTO', W / 2, H * .47);
    }

    /* 2-4. le tre sfumature, misurate sul PSD (posizione, colore, trasparenza) */
    sfumatura(x, W, H, [[0, 0, 0, 0, 0], [.5, 0, 0, 0, 0], [.6, 60, 60, 60, .04], [.65, 32, 32, 32, .12], [.7, 9, 9, 9, .25],
      [.75, 0, 0, 0, .38], [.8, 0, 0, 0, .52], [.85, 0, 0, 0, .67], [.9, 0, 0, 0, .82], [.95, 0, 0, 0, .95], [1, 0, 0, 0, 1]]);
    sfumatura(x, W, H, [[0, 201, 158, 105, 0], [.5, 201, 158, 105, 0], [.6, 212, 146, 94, .02], [.65, 219, 135, 87, .06],
      [.7, 226, 124, 77, .14], [.75, 232, 111, 67, .24], [.8, 239, 96, 57, .38], [.85, 244, 80, 45, .53], [.9, 248, 62, 33, .7],
      [.95, 252, 40, 19, .85], [1, 255, 7, 2, .98]]);
    sfumatura(x, W, H, [[0, 0, 0, 0, 1], [.05, 0, 0, 0, .84], [.1, 0, 0, 0, .62], [.15, 0, 0, 0, .4], [.2, 0, 0, 0, .2],
      [.25, 37, 37, 37, .055], [.3, 96, 96, 96, 0], [1, 255, 255, 255, 0]]);

    /* da qui in poi si lavora nelle misure del PSD (1400x2436) */
    x.save(); x.scale(W / 1400, H / 2436);

    /* 5. "01/10/2026" e "1° year" in luce soffusa, come nel PSD */
    x.save(); x.globalCompositeOperation = 'soft-light';
    x.textAlign = 'left'; x.fillStyle = '#290000'; fitText(x, '01/10/2026', 1357, 300, 'italic 900', F);
    x.fillText('01/10/2026', 25, 2465);
    x.globalAlpha = .35; x.fillStyle = '#fff'; fitText(x, '1° YEAR', 1247, 300, 'italic 900', F);
    x.fillText('1° YEAR', 80, 242);
    x.restore();

    /* 6. le trame a puntini (verde acqua e nera, già al 25% dentro al file) */
    if (data.trama && data.trama.complete && data.trama.naturalWidth) x.drawImage(data.trama, 0, 0, 1400, 2436);

    /* 7. in alto: il wordmark, 01 · ONE YEAR IN, la frase */
    x.textAlign = 'center'; x.textBaseline = 'alphabetic';
    if (data.wordmark && data.wordmark.complete && data.wordmark.naturalWidth) {
      var ww = 559, wh = ww * data.wordmark.naturalHeight / data.wordmark.naturalWidth;
      x.drawImage(data.wordmark, 418, 266, ww, wh);
    } else {
      x.fillStyle = '#fff'; x.font = 'italic 800 40px ' + F; x.fillText('ZENTORIDERS', 700, 298);
    }
    x.fillStyle = '#ff0000'; fitText(x, '01 · ONE YEAR IN', 1200, 190, 'italic 900', F);
    x.fillText('01 · ONE YEAR IN', 700, 466);
    var frase = (data.phrase || 'Stock was never the plan.').toUpperCase();
    x.fillStyle = '#fff'; fitText(x, frase, 1060, 50, '800', F);
    x.fillText(frase, 709, 546);

    /* 8. in basso: chi sei (finché non scrivi, restano le scritte guida) */
    x.textAlign = 'left';
    var grigio = '#c6c6c6';
    x.fillStyle = grigio; x.font = '800 47px ' + F; x.fillText('RIDER', 104, 1633);
    x.fillStyle = '#fff'; fitText(x, data.name || 'NOME RIDER', 1010, 150, 'italic 900', F); x.fillText(data.name || 'NOME RIDER', 102, 1795);
    x.fillStyle = grigio; fitText(x, data.bike || 'MODELLO MOTO', 900, 47, '800', F); x.fillText(data.bike || 'MODELLO MOTO', 104, 1882);
    x.strokeStyle = '#fff'; x.lineWidth = 4; x.setLineDash([26, 17]);
    x.beginPath(); x.moveTo(113, 1947); x.lineTo(994, 1947); x.stroke(); x.setLineDash([]);
    x.fillStyle = grigio; x.font = '800 48px ' + F; x.fillText('MEMBER SINCE', 113, 2041);
    x.fillStyle = '#fff'; x.font = '800 48px ' + F; x.fillText(data.since || '', 112, 2129);
    x.textAlign = 'right';
    x.fillStyle = '#fff'; x.font = '800 48px ' + F; x.fillText('RIDER N°', 1280, 1962);
    x.fillStyle = '#00e7c5'; fitText(x, data.num || '', 420, 158, '900', F); x.fillText(data.num || '', 1282, 2124);
    x.textAlign = 'left';

    /* 9. il logo Zento */
    if (data.logo && data.logo.complete && data.logo.naturalWidth) {
      var lw = 231, lh = lw * data.logo.naturalHeight / data.logo.naturalWidth;
      x.drawImage(data.logo, 584, 2236 - lh / 2, lw, lh);
    }
    x.restore();
    return c;
  }
  function story(box) {
    if (box.__zr) return; box.__zr = 1;
    var card = document.getElementById(box.getAttribute('data-zr-story'));
    if (!card) return;
    var img = box.querySelector('[data-zr-img]'), dl = box.querySelector('[data-zr-dl]'), sh = box.querySelector('[data-zr-share]');
    var msg = box.querySelector('[data-zr-msg]'), tip = box.querySelector('[data-zr-tip]');
    var inName = box.querySelector('[data-zr-sin="name"]'), inBike = box.querySelector('[data-zr-sin="bike"]');
    var inPhrase = box.querySelector('[data-zr-sin="phrase"]'), inPhoto = box.querySelector('[data-zr-sphoto]');
    var url = null, file = null, own = null, timer = 0, busy = false, again = false;
    var fotoScelta = null; /* il file vero: createImageBitmap lo vuole per raddrizzarlo */
    function carica(src) { return new Promise(function (ok) { if (!src) return ok(null); var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { ok(i); }; i.onerror = function () { ok(null); }; i.src = src; }); }
    var wmP = carica(box.getAttribute('data-wordmark')), lgP = carica(box.getAttribute('data-logo')), trP = carica(box.getAttribute('data-trama'));
    /* ⚠️ QUI CI SONO DUE POSIZIONI DIVERSE, e vanno tenute separate:
       - il POSTER ha i suoi cursori (data-zr-spos): riguardano solo il poster;
       - la CARD ha i suoi (data-zr-cpos), che il rider salva e che valgono dappertutto.
       Il VIDEO deve copiare la card (--px/--py/--pz sono gli stessi tre numeri con cui il
       browser la disegna), il POSTER deve ubbidire ai propri cursori. */

    /* la posizione dai cursori: tre campi che scorrono (z e in centesimi) */
    function posDaCursori(root) {
      var p = { x: 50, y: 50, z: 1 };
      if (!root) return p;
      [].forEach.call(root.querySelectorAll('input[data-k]'), function (i) {
        var k = i.getAttribute('data-k'), v = parseFloat(i.value);
        if (isFinite(v)) p[k] = k === 'z' ? v / 100 : v;
      });
      return p;
    }
    /* la posizione dalla card: quella vera, quella che si vede */
    function posDaCard(el) {
      var p = { x: 50, y: 50, z: 1 };
      if (!el) return p;
      var st = getComputedStyle(el);
      function n(k, se, min, max) {
        var v = parseFloat(st.getPropertyValue(k));
        return isFinite(v) ? Math.min(max, Math.max(min, v)) : se;
      }
      p.x = n('--px', 50, 0, 100); p.y = n('--py', 50, 0, 100); p.z = n('--pz', 1, 1, 2.5);
      return p;
    }

    /* i cursori del POSTER: lo ridisegnano, e compaiono quando si sceglie una foto */
    var spos = box.querySelector('[data-zr-spos]') || document.querySelector('[data-zr-spos]');
    if (spos) [].forEach.call(spos.querySelectorAll('input[data-k]'), function (i) { i.addEventListener('input', soon); });
    /* i cursori della CARD: ridisegnano il VIDEO */
    var cpos = document.querySelector('[data-zr-cpos]');
    if (cpos) [].forEach.call(cpos.querySelectorAll('input[data-k]'), function (i) { i.addEventListener('input', soon); });
    var canShare = false;
    try { canShare = !!(navigator.canShare && navigator.canShare({ files: [new File([new Blob(['x'])], 'x.png', { type: 'image/png' })] })); } catch (e) { canShare = false; }
    /* due passi: "Riscatta il poster" lo salva, poi compare "Pubblicalo su Instagram" (solo dove si può condividere) */
    var ris = box.querySelector('[data-zr-poster-ris]'), dopo = box.querySelector('[data-zr-dopo]');
    if (sh && !canShare) { sh.hidden = true; if (tip) tip.hidden = false; }

    function val(el, def) { var v = el ? String(el.value || '').replace(/\s+/g, ' ').trim() : ''; return v || def || ''; }
    function cardPhoto() {
      var bgEl = card.querySelector('.zr-bg');
      var m = bgEl && /url\(["']?([^"')]+)["']?\)/.exec(bgEl.style.backgroundImage || '');
      return m ? m[1] : '';
    }
    function render() {
      if (busy) { again = true; return; }
      busy = true; again = false;
      var cs = getComputedStyle(card), tier = card.getAttribute('data-tier');
      var data = {
        name: val(inName, '').toUpperCase().slice(0, 24),
        bike: val(inBike, '').toUpperCase().slice(0, 40),
        phrase: val(inPhrase, box.getAttribute('data-phrase') || '').slice(0, 60),
        num: ((card.querySelector('[data-zr-f="num"]') || {}).textContent || '').trim(),
        since: ((card.querySelector('[data-zr-f="since"]') || {}).textContent || '').trim(),
        accent: (cs.getPropertyValue('--t-acc') || '').trim() || '#00C6B3',
        base: tier === 'founding' ? '#0a0908' : tier === 'early' ? '#14161a' : tier === 'partner' ? '#060709' : '#151518',
        tones: (tier === 'founding' || tier === 'early' || tier === 'partner') ? tones(card) : [hex('#0c0c0e'), hex('#26262b'), hex('#5a1414')],
        year: ((card.querySelector('.zr-chip') || {}).textContent || 'YEAR 01').trim(),
        tag: box.getAttribute('data-tag') || '',
        font: fontOf(card), seed: parseFloat(card.getAttribute('data-seed')) || 0, img: null, pos: posDaCursori(spos)
      };
      /* la foto la deve mettere il rider: niente foto della card al suo posto */
      var src = own;
      function finish(withPhoto) {
        var c = drawStory(data, withPhoto);
        try {
          c.toBlob(function (b) {
            busy = false;
            if (!b) { if (withPhoto) { busy = true; return finish(false); } return; }
            if (url) URL.revokeObjectURL(url);
            url = URL.createObjectURL(b);
            var nome = 'zento-rider-' + (data.num || 'story').replace(/[^0-9a-z]+/gi, '') + '-story.png';
            file = (typeof File === 'function') ? new File([b], nome, { type: 'image/png' }) : null;
            if (img) img.src = url;
            if (dl) { dl.href = url; dl.setAttribute('download', nome); }
            if (msg) msg.textContent = '';
            pronto();
            if (again) render();
          }, 'image/png');
        } catch (e) { busy = false; if (withPhoto) { busy = true; finish(false); } else if (msg) msg.textContent = msg.getAttribute('data-err') || ''; }
      }
      function viaImmagine() {
        var im = new Image(); if (!/^blob:/.test(src)) im.crossOrigin = 'anonymous'; im.decoding = 'async';
        im.onload = function () { data.img = im; finish(true); };
        im.onerror = function () { finish(false); };
        im.src = src;
      }
      function go() {
        if (src) {
          /* Le foto scattate col telefono portano dentro un contrassegno di rotazione (EXIF).
             Alcuni browser lo applicano da soli e altri no: per questo alcune foto uscivano
             storte e altre dritte. Qui si chiede esplicitamente 'raddrizzala', e valgono tutte uguali. */
          if (fotoScelta && typeof createImageBitmap === 'function') {
            createImageBitmap(fotoScelta, { imageOrientation: 'from-image' })
              .then(function (bm) { data.img = bm; finish(true); })
              .catch(viaImmagine);
          } else viaImmagine();
        } else finish(false);
      }
      var attese = [wmP, lgP, trP];
      if (document.fonts && document.fonts.load) attese.push(document.fonts.load('italic 900 100px Inter'), document.fonts.load('700 40px Inter'));
      Promise.all(attese).then(function (r) { data.wordmark = r[0]; data.logo = r[1]; data.trama = r[2]; go(); }, go);
    }
    /* il poster si riscatta solo quando è davvero suo: nome, moto e foto */
    var manca = box.querySelector('[data-zr-manca]');
    function pronto() {
      var m = [];
      if (!val(inName)) m.push('nome');
      if (!val(inBike)) m.push('moto');
      if (!own) m.push('foto');
      var ok = !m.length && !!url;
      if (ris) ris.disabled = !ok;
      if (manca) {
        manca.classList.toggle('is-ok', !m.length);
        manca.textContent = m.length ? 'Per riscattarlo mancano: ' + m.join(', ').replace(/, ([^,]*)$/, ' e $1') + '.' : 'Pronto: è il tuo poster, col tuo numero.';
      }
      return ok;
    }
    if (ris) ris.addEventListener('click', function () {
      if (!pronto()) { if (inName && !val(inName)) inName.focus(); return; }
      if (dl && url) dl.click();
      if (manca) manca.hidden = true;
      if (dopo) { dopo.hidden = false; setTimeout(function () { dopo.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60); }
    });
    function soon() { clearTimeout(timer); pronto(); timer = setTimeout(render, 350); }
    [inName, inBike, inPhrase].forEach(function (el) { if (el) el.addEventListener('input', soon); });
    if (inPhoto) inPhoto.addEventListener('change', function () {
      var f = inPhoto.files && inPhoto.files[0];
      if (!f) return;
      if (!/^image\//.test(f.type) || f.size > 15 * 1024 * 1024) { inPhoto.value = ''; if (msg) msg.textContent = msg.getAttribute('data-bad') || ''; return; }
      if (own) URL.revokeObjectURL(own);
      own = URL.createObjectURL(f); fotoScelta = f;
      var lab = box.querySelector('[data-zr-sphoto-name]'); if (lab) lab.textContent = f.name;
      if (spos) spos.hidden = false;
      pronto();
      render();
    });
    if (sh) sh.addEventListener('click', function () {
      if (!pronto()) return;
      if (file && navigator.share) navigator.share({ files: [file], title: '01 · One year in · Zento Riders', text: box.getAttribute('data-tag') || '' }).catch(function () {});
    });
    /* ---- il video della card (zr-video.js) ---- */
    var vbox = document.querySelector('[data-zr-vbox]') || box;
    var vb = vbox.querySelector('[data-zr-video]'), vgo = vbox.querySelector('[data-zr-vgo]'), vmsg = vbox.querySelector('[data-zr-vmsg]');
    /* con il poster acceso ci sarebbero DUE agganci: il video va collegato una volta sola */
    if (vb && vb.__zrVid) return;
    if (vb) vb.__zrVid = 1;
    var vsh = vbox.querySelector('[data-zr-vshare]'), vdl = vbox.querySelector('[data-zr-vdl]'), vfile = null, vurl = null, recording = false;
    var vbar = vbox.querySelector('[data-zr-vbar]'), vbarI = vbar && vbar.querySelector('i');
    var screen = vbox.querySelector('[data-zr-vscreen]') || box.querySelector('.zrj-sx-screen');
    function videoData(done) {
      var cs = getComputedStyle(card), tier = card.getAttribute('data-tier'), dark = tier === 'founding' || tier === 'early' || tier === 'partner';
      var f = function (k) { return ((card.querySelector('[data-zr-f="' + k + '"]') || {}).textContent || '').trim(); };
      var d = {
        tier: tier, dark: dark, bg: dark ? '#040403' : '#050807',
        base: (cs.getPropertyValue('--t-base') || '#f4f2ee').trim(), acc: (cs.getPropertyValue('--t-acc') || '#e10600').trim(),
        ink: (cs.getPropertyValue('--t-ink') || '#111').trim(), ink2: (cs.getPropertyValue('--t-ink2') || 'rgba(0,0,0,.5)').trim(),
        tones: tones(card), chip: ((card.querySelector('.zr-chip') || {}).textContent || 'YEAR 01').trim(),
        name: val(inName, f('name') || 'RIDER').toUpperCase().slice(0, 24), num: f('num'), since: f('since'), status: f('status'),
        bike: val(inBike, f('bike').replace('—', '')).toUpperCase().slice(0, 40), ig: f('ig').replace(/^@/, ''),
        phrase: val(inPhrase, box.getAttribute('data-phrase') || '').slice(0, 60), tag: box.getAttribute('data-tag') || '',
        font: (cs.getPropertyValue('--zr-disp') || '').trim() || fontOf(card), mono: 'ui-monospace, Menlo, Consolas, monospace',
        img: null, pos: posDaCard(card)
      };
      var src = own || cardPhoto();
      if (!src) return done(d);
      var im = new Image(); if (!/^blob:/.test(src)) im.crossOrigin = 'anonymous';
      im.onload = function () { d.img = im; done(d); }; im.onerror = function () { done(d); }; im.src = src;
    }
    /* anteprima ferma del video: si disegna quando il riquadro entra in vista */
    var provaAnt = 0;
    function anteprima() {
      if (!screen || recording || screen.hasAttribute('data-zr-noprev') || screen.querySelector('canvas,video')) return;
      /* zr-video.js arriva con defer: se non c'è ancora, si riprova poco dopo */
      if (!window.ZRVideo) { if (provaAnt++ < 40) setTimeout(anteprima, 300); return; }
      videoData(function (d) {
        if (recording) return;
        ZRVideo.logo(d).then(function () {
          if (recording || screen.querySelector('canvas,video')) return;
          var cv = document.createElement('canvas'); cv.setAttribute('data-zr-vprev', '');
          screen.appendChild(cv);
          try { ZRVideo.frame(d, cv, 13.4); } catch (e) { cv.remove(); }
        });
      });
    }
    if (screen) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en, o) { if (en[0].isIntersecting) { o.disconnect(); anteprima(); } }, { rootMargin: '300px' }).observe(screen);
      } else setTimeout(anteprima, 1500);
    }
    function clearVid() { [].forEach.call(screen ? screen.querySelectorAll('canvas,video') : [], function (n) { n.remove(); }); }
    if (vb) vb.addEventListener('click', function () {
      if (recording) return;
      if (!window.ZRVideo || !ZRVideo.supported()) { if (vmsg) vmsg.textContent = vmsg.getAttribute('data-no'); return; }
      recording = true; vb.disabled = true; if (vgo) vgo.hidden = true;
      if (vbar) { vbar.hidden = false; if (vbarI) vbarI.style.width = '0%'; }
      if (vmsg) vmsg.textContent = vmsg.getAttribute('data-via') || 'Preparo il video…';
      videoData(function (d) {
        clearVid();
        var cv = document.createElement('canvas'); if (screen) screen.appendChild(cv);
        ZRVideo.make(d, cv, function (p) {
          if (vbarI) vbarI.style.width = Math.round(p * 100) + '%';
          if (vmsg) vmsg.textContent = 'Manca ' + Math.ceil(15 * (1 - p)) + ' s · ' + (vmsg.getAttribute('data-keep') || '');
        }).then(function (r) {
          recording = false; vb.disabled = false; vb.textContent = 'Rifai il video';
          if (vbar) vbar.hidden = true;
          if (vurl) URL.revokeObjectURL(vurl);
          vurl = URL.createObjectURL(r.blob);
          var nome = 'zento-rider-' + (d.num || 'card').replace(/[^0-9a-z]+/gi, '') + '.' + r.ext;
          vfile = (typeof File === 'function') ? new File([r.blob], nome, { type: r.type }) : null;
          clearVid();
          var v = document.createElement('video'); v.src = vurl; v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true; v.setAttribute('playsinline', '');
          if (screen) screen.appendChild(v); try { v.play(); } catch (e) {}
          if (vdl) { vdl.href = vurl; vdl.setAttribute('download', nome); }
          var ok = false; try { ok = !!(vfile && navigator.canShare && navigator.canShare({ files: [vfile] })); } catch (e) { ok = false; }
          if (vsh) vsh.hidden = !ok;
          if (vgo) vgo.hidden = false;
          if (vmsg) vmsg.textContent = r.ext === 'webm' ? 'Fatto. Se Instagram non lo accetta, aprilo da Safari o da Chrome aggiornato.' : 'Fatto. Il video resta sul tuo telefono.';
        }, function () {
          recording = false; vb.disabled = false; clearVid();
          if (vbar) vbar.hidden = true;
          if (vmsg) vmsg.textContent = vmsg.getAttribute('data-no') || '';
        });
      });
    });
    if (vsh) vsh.addEventListener('click', function () {
      if (vfile && navigator.share) navigator.share({ files: [vfile], title: '01 · One year in · Zento Riders', text: box.getAttribute('data-tag') || '' }).catch(function () {});
    });
    /* la prima anteprima appena la Story è aperta */
    function maybeStart() { if (box.getAttribute('data-state') !== 'prima' && box.getAttribute('data-state') !== 'chiusa') render(); }
    if ('MutationObserver' in window) new MutationObserver(maybeStart).observe(box, { attributes: true, attributeFilter: ['data-state'] });
    setTimeout(maybeStart, 60);
  }

  /* ── la foto della moto scelta nel modulo: si vede subito sulla card ── */
  function photoPick(inp) {
    if (inp.__zr) return; inp.__zr = 1;
    var form = inp.form, card = form && document.getElementById(form.getAttribute('data-zr-preview'));
    var box = inp.closest('[data-zr-up]'), url = null;
    inp.addEventListener('change', function () {
      var f = inp.files && inp.files[0];
      if (!f) return;
      if (!/^image\//.test(f.type) || f.size > 15 * 1024 * 1024) { inp.value = ''; if (box) box.classList.add('is-bad'); return; }
      if (box) box.classList.remove('is-bad');
      if (url) URL.revokeObjectURL(url);
      url = URL.createObjectURL(f);
      if (card) { var bg = card.querySelector('.zr-bg'); if (bg) bg.style.backgroundImage = 'url("' + url + '")'; }
      if (box) {
        box.classList.add('has-file');
        var th = box.querySelector('[data-zr-up-thumb]'); if (th) th.style.backgroundImage = 'url("' + url + '")';
        var nm = box.querySelector('[data-zr-up-name]'); if (nm) nm.textContent = f.name;
      }
    });
  }

  /* ── lo sfondo a puntini della testata (come il componente "Dithering", forma "warp",
        retino 4x4): fondo trasparente, puntini del verde acqua della pagina.
        Va piano; quando ci passi sopra accelera. Si ferma quando non si vede. ── */
  var BG_FS = [
    /* la parte decimale di numeri grandi serve intera: a meta precisione si perde
       e la trama diventa una tinta piatta (succedeva su Android) */
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform vec2 uR;uniform float uT;uniform float uP;uniform vec3 uC;',
    /* (Mirco 27.10, Mac 2016: lo sfondo veniva "a blocchi" coi bordi dritti) il vecchio hash moltiplicava per 456 dei
     numeri che arrivano a ~400: 190.000, e la parte decimale di numeri cosi grandi certe schede grafiche (Intel su Mac)
     la sbagliano. Ora le coordinate si riportano sotto 289 e l'hash (Dave Hoskins) lavora solo con numeri piccoli:
     lo stesso disegno a onde, uguale su tutte le macchine. */
    'float h(vec2 p){p=mod(p,289.);vec3 q=fract(vec3(p.xyx)*.1031);q+=dot(q,q.yzx+33.33);return fract((q.x+q.y)*q.z);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);',
    ' return mix(mix(h(i),h(i+vec2(1.,0.)),u.x),mix(h(i+vec2(0.,1.)),h(i+vec2(1.,1.)),u.x),u.y);}',
    'float fb(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p=p*2.02+11.3;a*=.5;}return v;}',
    'float b2(vec2 a){a=floor(a);return fract(a.x/2.+a.y*a.y*.75);}',
    'float b4(vec2 a){return b2(.5*a)*.25+b2(a);}',
    'void main(){',
    ' vec2 px=floor(gl_FragCoord.xy/uP);vec2 uv=px*uP/uR.y;float t=uT;',
    ' vec2 q=vec2(fb(uv*1.2+vec2(0.,t*.35)),fb(uv*1.2+vec2(5.2,-t*.3)));',
    ' vec2 r=vec2(fb(uv*1.4+3.*q+vec2(1.7,9.2)+t*.2),fb(uv*1.4+3.*q+vec2(8.3,2.8)-t*.15));',
    ' float v=fb(uv*1.1+3.2*r);v=smoothstep(.25,.85,v);',
    /* il retino 4x4 dipende solo da px modulo 4: senza mod, a.y*a.y su schermi grandi perde i decimali
       e i puntini diventano blocchi che si ripetono (Mac, Mirco 13.10). Con mod il risultato e IDENTICO. */
    ' float on=step(b4(mod(px,4.))+.02,v);',
    ' gl_FragColor=vec4(uC*on,on);}'
  ].join('\n');
  function bgDither(box) {
    if (box.__zr) return; box.__zr = 1;
    var cv = box.querySelector('canvas'); if (!cv) return;
    var g = null, o = { antialias: false, alpha: true, depth: false, stencil: false, premultipliedAlpha: true, powerPreference: 'low-power' };
    try { g = cv.getContext('webgl2', o) || cv.getContext('webgl', o); } catch (e) { g = null; }
    if (!g) { box.classList.add('is-off'); return; }
    if (!precisionePiena(g)) { box.classList.add('is-off'); return; }
    function sh(type, src) { var s = g.createShader(type); g.shaderSource(s, src); g.compileShader(s); return g.getShaderParameter(s, g.COMPILE_STATUS) ? s : null; }
    var vs = sh(g.VERTEX_SHADER, VS), fs = sh(g.FRAGMENT_SHADER, BG_FS);
    if (!vs || !fs) { box.classList.add('is-off'); return; }
    var pr = g.createProgram(); g.attachShader(pr, vs); g.attachShader(pr, fs); g.linkProgram(pr);
    if (!g.getProgramParameter(pr, g.LINK_STATUS)) { box.classList.add('is-off'); return; }
    g.useProgram(pr);
    var bf = g.createBuffer(); g.bindBuffer(g.ARRAY_BUFFER, bf);
    g.bufferData(g.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), g.STATIC_DRAW);
    var loc = g.getAttribLocation(pr, 'p'); g.enableVertexAttribArray(loc); g.vertexAttribPointer(loc, 2, g.FLOAT, false, 0, 0);
    var U = {}; ['uR', 'uT', 'uP', 'uC'].forEach(function (k) { U[k] = g.getUniformLocation(pr, k); });
    g.uniform3fv(U.uC, hex(getComputedStyle(box).getPropertyValue('--zr-acc') || '#00C6B3'));
    var touch = window.matchMedia && matchMedia('(hover: none)').matches, base = touch ? 0.55 : 0.2;
    var misuratoSf = false;
    var host = box.closest('section') || box, speed = base, want = base, acc = 0, t0 = 0, run = false, vis = true, raf = 0, st = 0;
    /* data-zr-calmo (striscia della spedizione, 18.10): niente accelerate col mouse o scorrendo, solo il moto lento */
    if (!box.hasAttribute('data-zr-calmo')) {
      host.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') want = 0.6; });
      host.addEventListener('pointerleave', function () { want = base; });
      if (touch) window.addEventListener('scroll', function () { want = 1.1; clearTimeout(st); st = setTimeout(function () { want = base; }, 700); }, { passive: true });
    } else { base = want = speed = 0.2; }
    /* come per le card: senza una misura vera non si disegna (vedi misuraVera) */
    /* (24.10, Mirco: "sul Mac lo sfondo si moltiplica e fa laggare tutto")
       Prima la tela era grande quanto lo schermo VERO: su un Retina ogni quadratino da 2 px CSS erano 4x4 = 16 pixel
       calcolati uno per uno, 60 volte al secondo, con un rumore pesante. Ora la tela ha UN pixel per quadratino
       (16 volte meno lavoro a densita 2) e il browser la ingrandisce senza sfumare (pixelated): il disegno e lo stesso,
       e la griglia cade sempre esatta sui pixel CSS. In piu si disegna al massimo 24 volte al secondo: va piano. */
    cv.style.imageRendering = 'pixelated';
    function size() {
      var w = cv.clientWidth, h = cv.clientHeight;
      if (!(w > 0 && h > 0)) return false;
      /* (Mirco 27.10: "sul telefono lo sfondo è molto zoomato, lo vorrei più lontano, che si veda di più")
         Sul telefono un quadratino è 4 pixel VERI dello schermo (su un iPhone 1,33 punti invece di 2) e le onde sono
         1,6 volte più fitte: si vede più disegno, con puntini più piccoli. Sul computer resta tutto com'era. */
      var tel = window.innerWidth < 750, dpr = window.devicePixelRatio || 1;
      var passo = tel ? Math.max(1, 4 / dpr) : 2, zoom = tel ? 1.6 : 1;
      var cw = Math.max(1, Math.ceil(w / passo)), ch = Math.max(1, Math.ceil(h / passo));
      if (cv.width !== cw || cv.height !== ch) { cv.width = cw; cv.height = ch; }
      g.viewport(0, 0, cw, ch); g.uniform2f(U.uR, cw, ch / zoom); g.uniform1f(U.uP, 1);
      misuratoSf = true; return true;
    }
    function draw() { if (!misuratoSf) return; g.clearColor(0, 0, 0, 0); g.clear(g.COLOR_BUFFER_BIT); g.uniform1f(U.uT, acc); g.drawArrays(g.TRIANGLE_STRIP, 0, 4); }
    var ultimo = 0;
    function frame(now) {
      raf = 0; if (!run) return;
      var dt = Math.min(64, now - t0) / 1000; t0 = now;
      speed += (want - speed) * Math.min(1, dt * 3);
      acc += dt * speed;
      if (now - ultimo >= 41) { ultimo = now; draw(); }
      raf = requestAnimationFrame(frame);
    }
    /* data-zr-fermo (piede del sito, Mirco 19.10: 'non animato'): si disegna una volta e basta */
    var fermo = box.hasAttribute('data-zr-fermo');
    function play() {
      var on = vis && !document.hidden && !reduce && !fermo;
      if (on && !run) { run = true; t0 = performance.now(); raf = requestAnimationFrame(frame); }
      if (!on && run) { run = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
    }
    acc = 3.7;
    quandoMisurabile(cv, function () { size(); draw(); }, function () { box.classList.add('is-off'); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (size()) draw(); }).observe(cv);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { vis = en[0].isIntersecting; play(); }).observe(box);
    document.addEventListener('visibilitychange', play);
    play();
  }

  /* ── l'orbita: si adatta allo schermo e parte quando la vedi ── */
  function orbit(el) {
    if (el.__zr) return; el.__zr = 1;
    var frame = el.querySelector('.zro-frame');
    function fit() { if (frame) el.style.setProperty('--s', Math.min(1, Math.max(0.6, frame.clientWidth / 1200)).toFixed(4)); }
    fit();
    if ('ResizeObserver' in window && frame) new ResizeObserver(fit).observe(frame);
    function countUp() {
      [].forEach.call(el.querySelectorAll('[data-zr-to]'), function (b, i) {
        var txt = b.getAttribute('data-zr-to'), to = parseInt(txt, 10), len = txt.length;
        if (reduce || isNaN(to) || !/^\d+$/.test(txt)) { b.textContent = txt; return; }
        var t0 = null, delay = 900 + i * 120, dur = 1600;
        function step(now) {
          if (t0 === null) t0 = now;
          var p = Math.min(1, Math.max(0, (now - t0 - delay) / dur)), e = 1 - Math.pow(1 - p, 4);
          b.textContent = String(Math.round(to * e)).padStart(len, '0');
          if (p < 1) requestAnimationFrame(step);
        }
        b.textContent = String(0).padStart(len, '0');
        requestAnimationFrame(step);
      });
    }
    var done = false;
    function go() { if (done) return; done = true; el.classList.add('is-in'); countUp(); }
    /* sul telefono (e se qualcosa va storto) si accende comunque: niente pezzi invisibili */
    if (reduce || !('IntersectionObserver' in window) || window.innerWidth < 700) { go(); return; }
    setTimeout(go, 4000);
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { io.disconnect(); go(); }
    }, { threshold: 0.2 });
    io.observe(el);
  }

  /* ── Rewards: apre il pannello punti dell'app fedeltà (il pulsante in basso a sinistra) ── */
  /* foto della card: la sposti e la ingrandisci; "Salva" apre l'area personale che la ricorda */
  function cardPos(box) {
    if (box.__zr) return; box.__zr = 1;
    /* data-zr-cpos elenca TUTTE le card da muovere insieme: quella grande e quella del video,
       cosi si vede subito cosa uscira nel filmato invece di scoprirlo dopo. */
    var carte = (box.getAttribute('data-zr-cpos') || '').split(',').map(function (i) { return document.getElementById(i.trim()); }).filter(Boolean);
    var card = carte[0]; if (!card) return;
    var ins = box.querySelectorAll('input[data-k]'), save = box.querySelector('[data-zr-cpos-save]'), reset = box.querySelector('[data-zr-cpos-reset]');
    function read() { var p = {}; [].forEach.call(ins, function (i) { p[i.getAttribute('data-k')] = Math.round(parseFloat(i.value)); }); return p; }
    var msg = box.querySelector('[data-zr-cpos-msg]');
    function dico(t, buono) {
      if (!msg) return;
      msg.hidden = !t; msg.textContent = t || ''; msg.setAttribute('data-ok', buono ? '1' : '0');
    }
    function apply() {
      var p = read();
      carte.forEach(function (c) {
        c.style.setProperty('--px', p.x + '%'); c.style.setProperty('--py', p.y + '%'); c.style.setProperty('--pz', (p.z / 100).toFixed(2));
      });
      if (save) save.disabled = !box.getAttribute('data-save');
    }
    /* Salva DAVVERO, restando su questa pagina. Prima questo tasto era un link verso l area
       personale con ?pos=38,50,120 in coda: Shopify quel pezzo lo butta, quindi non salvava
       niente e in cambio ti portava sulla sua schermata. */
    if (save) save.addEventListener('click', function () {
      var base = box.getAttribute('data-save'); if (!base) return;
      var p = read();
      save.disabled = true; dico('Salvo…', true);
      fetch(base, {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({x: p.x, y: p.y, z: p.z}),
      }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return {r: r, j: j}; }); })
        .then(function (o) {
          save.disabled = false;
          if (o.r.ok && o.j.ok) { dico('Salvata: la foto sta cosi anche nel video e nella Hall of Fame.', true); return; }
          dico(o.j.error || 'Non sono riuscito a salvarla. Riprova.', false);
        })
        .catch(function () { save.disabled = false; dico('Non sono riuscito a salvarla. Riprova.', false); });
    });
    [].forEach.call(ins, function (i) { i.addEventListener('input', apply); });
    if (reset) reset.addEventListener('click', function () { [].forEach.call(ins, function (i) { i.value = i.getAttribute('data-k') === 'z' ? 100 : 50; }); apply(); });
    apply();
  }

  function rewards(a) {
    if (a.__zr) return; a.__zr = 1;
    a.addEventListener('click', function (e) {
      var app = document.getElementById('honeypop-app');
      var b = app && (app.querySelector('button[class*="Launcher"]') || app.querySelector('button'));
      if (b) { e.preventDefault(); b.click(); }
      else if (a.tagName === 'BUTTON') location.href = '/account';
      /* se l'app non c'è, il link porta all'account: niente vicoli ciechi */
    });
  }

  /* ── la Story ha una finestra: prima è chiusa (col conto alla rovescia), poi aperta, poi finita ── */
  function storyWindow(box) {
    if (box.__zrw) return; box.__zrw = 1;
    var from = Date.parse(box.getAttribute('data-from')), to = Date.parse(box.getAttribute('data-to'));
    function set() {
      var now = Date.now(), st = 'aperta';
      if (!box.hasAttribute('data-force')) {
        if (!isNaN(from) && now < from) st = 'prima';
        else if (!isNaN(to) && now >= to) st = 'chiusa';
      }
      box.setAttribute('data-state', st);
      return st;
    }
    if (set() !== 'chiusa') { var iv = setInterval(function () { if (set() === 'chiusa') clearInterval(iv); }, 1000); }
  }

  /* ── le card della Hall of Fame si preparano solo quando stanno per entrare nello schermo:
        con centinaia di rider, foto e sfondi si caricano man mano che scorri, non tutti insieme ── */
  var pigre = null;
  function sveglia(card) {
    var bg = card.querySelector('.zr-bg[data-bg]');
    if (bg) { bg.style.backgroundImage = "url('" + bg.getAttribute('data-bg') + "')"; bg.removeAttribute('data-bg'); }
    initCard(card);
  }
  function cardPigra(card) {
    if (card.__zr) return;
    if (card.hasAttribute('data-live') || !card.querySelector('.zr-bg[data-bg]') || !('IntersectionObserver' in window)) { sveglia(card); return; }
    if (!pigre) pigre = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { if (v.isIntersecting) { pigre.unobserve(v.target); sveglia(v.target); } });
    }, { rootMargin: '600px 0px' });
    pigre.observe(card);
  }


  /* ── ENTRARE NEL CLUB DALLA PAGINA, senza account ──
     Il tasto apre il modulo; l invio va a /apps/zento/iscrivi, che se non trova un
     cliente con quella email lo crea. Poi la pagina diventa l attesa.
     La foto si prepara QUI (rimpicciolita e raddrizzata) perche al servizio arrivi
     leggera: e la stessa catena che ha risolto il caricamento da iPhone. */
  function entraSubito(bottone) {
    if (bottone.__zr) return; bottone.__zr = 1;
    var form = document.querySelector('[data-zr-ent]');
    var att = document.querySelector('[data-zr-ent-att]');
    if (!form || !att) return;
    var inFoto = form.querySelector('[data-zr-ent-foto]');
    var nomeFoto = form.querySelector('[data-zr-ent-nome]');
    var msg = form.querySelector('[data-zr-ent-msg]');
    var ant = form.querySelector('[data-zr-ent-ant]');
    /* l anteprima e la card vera: la foto va nel suo .zr-bg, esattamente come fa il sito */
    var cardAnteprima = ant && ant.querySelector('#zr-card-ant');
    var antBox = cardAnteprima && cardAnteprima.querySelector('.zr-bg');
    /* gli stessi tre numeri che usa la card: x e y in percentuale, z lo zoom */
    function leggiPos() {
      var p = { x: 50, y: 50, z: 100 };
      if (!ant) return p;
      [].forEach.call(ant.querySelectorAll('input[data-k]'), function (i) {
        var v = parseInt(i.value, 10); if (isFinite(v)) p[i.getAttribute('data-k')] = v;
      });
      return p;
    }
    function mostraPos() {
      if (!ant) return;
      var p = leggiPos();
      /* i tre numeri vanno sulla CARD, che e chi li usa davvero */
      var dove = cardAnteprima || ant;
      dove.style.setProperty('--px', p.x + '%');
      dove.style.setProperty('--py', p.y + '%');
      dove.style.setProperty('--pz', (p.z / 100).toFixed(2));
    }
    if (ant && !giaCollegato) [].forEach.call(ant.querySelectorAll('input[data-k]'), function (i) { i.addEventListener('input', mostraPos); });
    /* nome e moto si scrivono sulla card mentre li digitano: e la cosa che stanno
       costruendo, non un modulo */
    function scriviSullaCard(chiave, valore, seVuoto) {
      if (!cardAnteprima) return;
      [].forEach.call(cardAnteprima.querySelectorAll('[data-zr-f="' + chiave + '"]'), function (t) {
        t.textContent = valore || seVuoto;
      });
    }
    if (!giaCollegato) {
      var inN = form.querySelector('[name="nome"]'), inM = form.querySelector('[name="moto"]');
      if (inN) inN.addEventListener('input', function () { scriviSullaCard('name', inN.value.toUpperCase().slice(0, 24), 'IL TUO NOME'); });
      if (inM) inM.addEventListener('input', function () { scriviSullaCard('bike', inM.value.toUpperCase().slice(0, 40), 'LA TUA MOTO'); });
    }
    var go = form.querySelector('[data-zr-ent-go]');
    var foto = null, LATO = 1600;
    /* ⚠️ i tasti che aprono il modulo possono essere piu di uno (testata + pagina):
       il modulo va collegato UNA volta sola, se no l invio parte due volte. */
    var giaCollegato = !!form.__zrEnt;
    form.__zrEnt = 1;

    function dico(t, buono) {
      if (!msg) return;
      msg.hidden = !t; msg.textContent = t || ''; msg.setAttribute('data-ok', buono ? '1' : '0');
    }
    bottone.addEventListener('click', function () {
      bottone.setAttribute('aria-expanded', 'true');
      form.hidden = false;
      var p = form.querySelector('input[name="nome"]');
      if (p) p.focus({ preventScroll: true });
      form.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });

    /* la foto: aperta gia piccola (Safari molla sulle foto intere), RADDRIZZATA
       (imageOrientation) e ridotta. Senza 'from-image' alcune escono storte e altre no. */
    function apri(blob) {
      if (typeof createImageBitmap !== 'function') {
        return new Promise(function (ok, ko) {
          var u = URL.createObjectURL(blob), im = new Image();
          im.onload = function () { ok(im); };
          im.onerror = function () { URL.revokeObjectURL(u); ko(new Error('il browser non apre questa immagine')); };
          im.src = u;
        });
      }
      return createImageBitmap(blob, { resizeWidth: LATO, resizeQuality: 'high', imageOrientation: 'from-image' })
        .catch(function () { return createImageBitmap(blob, { imageOrientation: 'from-image' }); })
        .catch(function () { return createImageBitmap(blob); });
    }
    function riduci(src) {
      var W = src.width || src.naturalWidth, H = src.height || src.naturalHeight;
      var k = Math.min(1, LATO / Math.max(W, H));
      var cv = document.createElement('canvas');
      cv.width = Math.max(1, Math.round(W * k)); cv.height = Math.max(1, Math.round(H * k));
      cv.getContext('2d').drawImage(src, 0, 0, cv.width, cv.height);
      return new Promise(function (ok, ko) {
        if (!cv.toBlob) return ko(new Error('questo browser non sa salvare l immagine'));
        cv.toBlob(function (b) { b ? ok(b) : ko(new Error('la riduzione non ha prodotto niente')); }, 'image/jpeg', 0.82);
      });
    }
    function inBase64(blob) {
      return new Promise(function (ok, ko) {
        var fr = new FileReader();
        fr.onload = function () { ok(String(fr.result).replace(/^data:[^,]*,/, '')); };
        fr.onerror = function () { ko(fr.error || new Error('non riesco a preparare la foto')); };
        fr.readAsDataURL(blob);
      });
    }
    if (inFoto && !giaCollegato) inFoto.addEventListener('change', function () {
      var f = inFoto.files && inFoto.files[0];
      if (!f) return;
      foto = null;
      if (nomeFoto) nomeFoto.textContent = 'Preparo la foto…';
      apri(f).then(riduci).then(inBase64).then(function (b64) {
        foto = b64;
        if (nomeFoto) nomeFoto.textContent = f.name;
        /* la si fa vedere subito nella forma della card: cosi la sistemano adesso,
           che e l unico momento in cui ci stanno davvero pensando */
        if (ant && antBox) {
          antBox.style.backgroundImage = 'url(data:image/jpeg;base64,' + b64 + ')';
          ant.hidden = false;
          mostraPos();
        }
        dico('', true);
      }).catch(function (e) {
        if (nomeFoto) nomeFoto.textContent = 'Questa foto non si apre: provane un altra';
        dico('Non sono riuscito a leggere la foto. Provane un altra, oppure mandacela su WhatsApp dopo.', false);
      });
    });

    if (!giaCollegato) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? String(el.value || '').trim() : ''; };
      var nome = v('nome'), moto = v('moto'), email = v('email'), ig = v('ig');
      var hof = !!form.querySelector('[name="hof"]:checked');
      /* si dice cosa manca UNA cosa per volta: una lista di errori spaventa */
      if (!nome) return dico('Manca il nome.', false);
      if (!moto) return dico('Manca la moto.', false);
      var chio = email.indexOf('@'), pun = email.lastIndexOf('.');
      if (chio < 1 || pun < chio + 2 || pun > email.length - 3 || email.indexOf(' ') >= 0) return dico('Controlla l email: e li che ti scriviamo.', false);
      if (!foto) return dico('Manca la foto della moto: e quella che finisce sulla card.', false);

      go.disabled = true; dico('Ti sto iscrivendo…', true);
      fetch('/apps/zento/iscrivi', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nome: nome, moto: moto, email: email, ig: ig, hof: hof, foto: foto, tipoFoto: 'image/jpeg', pos: leggiPos() })
      }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { r: r, j: j }; }); })
        .then(function (o) {
          go.disabled = false;
          if (!o.r.ok || !o.j.ok) {
            dico(o.j.error || 'Non sono riuscito a mandare la richiesta. Riprova fra poco.', false);
            return;
          }
          /* da qui in poi la pagina e l attesa: il modulo sparisce */
          form.hidden = true; att.hidden = false;
          var m = att.querySelector('[data-zr-ent-att-mail]');
          if (m) m.textContent = 'Ti abbiamo scritto a ' + email + '.';
          att.scrollIntoView({ block: 'center', behavior: 'smooth' });
          try { localStorage.setItem('zrClubInviata', '1'); } catch (x) {}
        })
        .catch(function () {
          go.disabled = false;
          dico('Connessione persa. Riprova fra poco.', false);
        });
    });

    /* se la richiesta e gia partita da questo dispositivo, non si ricomincia da capo */
    try {
      if (localStorage.getItem('zrClubInviata') === '1') { bottone.hidden = true; att.hidden = false; }
    } catch (x) {}
  }

  /* "Ritira": il Rider dichiara una cosa che non possiamo verificare. Non accredita
     niente da solo — manda la richiesta, e i punti li da Mirco dal pannello. Il tasto
     si spegne subito, cosi non si puo chiedere due volte. */
  function ritira(b) {
    if (b.__zr) return; b.__zr = 1;
    b.addEventListener('click', function () {
      var quale = b.getAttribute('data-zr-ritira');
      b.disabled = true; b.textContent = 'Invio…';
      fetch('/apps/zento/ritira', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quale: quale })
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (j) {
          if (j.ok) { b.textContent = j.stato === 'approvato' ? 'Presi' : 'In attesa'; return; }
          b.disabled = false; b.textContent = 'Ritira';
          if (j.error) alert(j.error);
        })
        .catch(function () { b.disabled = false; b.textContent = 'Ritira'; });
    });
  }
  function boot(root) {
    root = root || document;
    [].forEach.call(root.querySelectorAll('.zr-card'), cardPigra);
    [].forEach.call(root.querySelectorAll('[data-zr-count]'), count);
    [].forEach.call(root.querySelectorAll('form[data-zr-preview]'), bind);
    [].forEach.call(root.querySelectorAll('[data-zr-story]'), story);
    [].forEach.call(root.querySelectorAll('input[data-zr-photo]'), photoPick);
    [].forEach.call(root.querySelectorAll('[data-zr-orbit]'), orbit);
    [].forEach.call(root.querySelectorAll('[data-zr-entra]'), entraSubito);
    [].forEach.call(root.querySelectorAll('[data-zr-ritira]'), ritira);
    [].forEach.call(root.querySelectorAll('[data-zr-bgd]'), bgDither);
    [].forEach.call(root.querySelectorAll('[data-zr-window]'), storyWindow);
    [].forEach.call(root.querySelectorAll('[data-zr-rewards]'), rewards);
    [].forEach.call(root.querySelectorAll('[data-zr-cpos]'), cardPos);
    /* le lucine sugli archi della testata: ferme per chi ha chiesto meno animazioni */
    if (reduce) [].forEach.call(root.querySelectorAll('svg.zr-arcs'), function (s) { try { s.pauseAnimations(); } catch (e) {} });
  }

  window.ZR = { boot: boot, still: still, recolor: function (c) { if (c && c.__zrRecolor) c.__zrRecolor(); else if (c) useStill(c); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  /* nell'editor del tema le sezioni si ricaricano da sole: le riaccendo */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
